import React, { Fragment, useState } from "react";
import {
  Form,
  Row,
  Col,
  Container,
  InputGroup,
  Button,
  DropdownButton,
  Dropdown,
  FormControl,
  Select,
} from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import MultiSelect from "react-multi-select-component";

const schema = yup.object({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  username: yup.string().required(),
  city: yup.string().required(),
  state: yup.string().required(),
  zip: yup.string().required(),
  terms: yup.bool().required(),
});

function Searchv2() {
  const [selected, setSelected] = useState([]);

  const options = [
    { label: "Grapes", value: "grapes" },
    { label: "Mango", value: "mango" },
    { label: "Mango", value: "mango" },
    { label: "Mango", value: "mango" },
    { label: "Mango", value: "mango" },
    { label: "Mango", value: "mango" },

    { label: "Strawberry", value: "strawberry", disabled: true },
  ];
  const filters = [
    {
      name: "Handler",
      columnSize: 3,
    },
    {
      name: "Status",
      columnSize: 3,
    },
    {
      name: "Category",
      columnSize: 3,
    },
    {
      name: "Type",
      columnSize: 3,
    },
    {
      name: "Street Address",
      columnSize: 4,
    },
    {
      name: "City",
      columnSize: 3,
    },
    {
      name: "County",
      columnSize: 3,
    },
    {
      name: "Zip Code",
      columnSize: 2,
    },
  ];
  return (
    <Fragment>
      <Formik
        validationSchema={schema}
        onSubmit={console.log}
        initialValues={{
          firstName: "Mark",
          lastName: "Otto",
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <div
              className="section section-search"
              style={{ paddingBottom: 0, overflow: "visible" }}
            >
              <Container>
                <Form.Row>
                  <InputGroup
                    as={Col}
                    xl="8"
                    lg="7"
                    md="12"
                    m="3"
                    className="mb-3"
                  >
                    <InputGroup.Prepend>
                      <Form.Control as="select" style={{ width: 100 }}>
                        <option>EPA ID</option>
                        <option>Facility Name</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                      </Form.Control>
                    </InputGroup.Prepend>
                    <FormControl
                      placeholder="Recipient's username"
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                    />
                    <InputGroup.Append>
                      <Button variant="outline-secondary">
                        {" "}
                        <span className="ca-gov-icon-search formearch"></span>
                      </Button>
                    </InputGroup.Append>
                  </InputGroup>
                  <Form.Group as={Col} xl="2" lg="3" md="6">
                    <Button
                      style={{ width: "100%" }}
                      href="#agencyFilters"
                      variant="secondary"
                      class="btn filter-toggle toggle-more m-y btn-block-xs collapsed"
                      role="tab"
                      data-toggle="collapse"
                      data-parent="#agencyFilters"
                      aria-expanded="false"
                      aria-controls="agencyFilters"
                      aria-selected="false"
                      id="ui-collapse-98"
                      tabindex="-1"
                    >
                      <span class="toggle-more" aria-expanded="false">
                        Advanced Filters{" "}
                        <span
                          class="ca-gov-icon-filter"
                          aria-hidden="true"
                        ></span>
                      </span>
                    </Button>
                  </Form.Group>
                  <Form.Group as={Col} xl="1" lg="1" md="6">
                    <Button variant="outline-secondary">
                      <span className="ca-gov-icon-table"></span>
                    </Button>
                  </Form.Group>
                </Form.Row>

                <div
                  class="agencyFilters filter-group m-b-sm collapse"
                  id="agencyFilters"
                  role="tabpanel"
                  tabindex="-1"
                  aria-labelledby="ui-collapse-98"
                  aria-hidden="true"
                >
                  <Form.Row>
                    {filters.map((f, i) => (
                      <Form.Group
                        as={Col}
                        xl={f.columnSize}
                        lg="3"
                        md="6"
                        sm="12"
                      >
                        <MultiSelect
                          as="select"
                          options={options}
                          value={selected}
                          onChange={setSelected}
                          labelledBy={"Select"}
                        />
                      </Form.Group>
                    ))}
                    {/* <Form.Group as={Col} xl="2">
                      <button>Update</button>
                      <button>Reset</button>
                    </Form.Group> */}
                  </Form.Row>
                </div>
              </Container>
            </div>

            {/* <div className="section section-default" style={{ zIndex: 999 }}>
              <Container>
                <Form.Row>
                  <InputGroup as={Col} md="9" className="mb-3">
                    <DropdownButton
                      as={InputGroup.Prepend}
                      variant="outline-secondary"
                      title="Search by"
                      id="input-group-dropdown-1"
                    >
                      <Dropdown.Item href="#">Action</Dropdown.Item>
                      <Dropdown.Item href="#">Another action</Dropdown.Item>
                      <Dropdown.Item href="#">
                        Something else here
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item href="#">Separated link</Dropdown.Item>
                    </DropdownButton>
                    <FormControl aria-describedby="basic-addon1" />
                    <Button as={InputGroup.Append} variant="outline-secondary">
                      <span className="ca-gov-icon-search formearch"></span>
                    </Button>
                  </InputGroup>
                  <Form.Group as={Col} md="2">
                    <Button
                      style={{ width: "100%" }}
                      variant="outline-secondary"
                    >
                      Advanced Filters{" "}
                      <span className="ca-gov-icon-filter"></span>
                    </Button>
                  </Form.Group>
                  <Form.Group as={Col} md="1">
                    <Button variant="outline-secondary">
                      <span className="ca-gov-icon-table"></span>
                    </Button>
                  </Form.Group>
                </Form.Row>
                <div
                  className="collapse agencyFilters filter-group"
                  id="agencyFilters"
                  role="tabpanel"
                  aria-multiselectable="true"
                  //tabIndex="-1"
                  aria-labelledby="ui-collapse-163"
                  aria-hidden="true"
                  style={{ border: "none" }}
                >
                  <Form.Row>
                    <Form.Group as={Col} md="2">
                      <Form.Control
                        type="text"
                        name="firstName"
                        placeholder="Search"
                        value={values.firstName}
                        onChange={handleChange}
                        isValid={touched.firstName && !errors.firstName}
                      />
                    </Form.Group>
                  </Form.Row>
                </div>
              </Container>
            </div> */}
          </Form>
        )}
      </Formik>
      <div>hi</div>
      {/* <div className="section section-default">
        <Container>
          <Row>
            <Col md="10">
              <Form.Group>
                <Form.Control type="text" placeholder="Search" />
              </Form.Group>
            </Col>
            <Col md="2">
              <button>Click Me</button>
            </Col>
          </Row>
        </Container>
      </div> */}
    </Fragment>
  );
}

export default Searchv2;
